import React from 'react';

function OuiNonBadge({ value }) {
    if (value === null || value === undefined) return <span className={"info-value--plain"}>—</span>;
    return <span className={`badge-bool badge-bool--${value ? 'oui' : 'non'}`}>{value ? 'Oui' : 'Non'}</span>;
}

function InfoRow({ label, children }) {
    return (
        <div className={"info-row"}>
            <span className={"info-label"}>{label}</span>
            <span className={"info-value-right"}>{children}</span>
        </div>
    );
}

function RcgInfoCard({ productRcg }) {
    if (!productRcg) return null;

    return (
        <div className={"panel-card info-card"}>
            <div className={"info-card-header"}>
                <i className={"fa fa-info-circle"}></i>
                <span>Informations complémentaires</span>
            </div>

            <div className={"info-product"}>
                <p className={"info-product-name"}>{productRcg.product?.name ?? '—'}</p>
                <p className={"info-product-manufacturer"}>{productRcg.manufacturer?.name ?? '—'}</p>
            </div>

            <div className={"info-rows"}>
                <InfoRow label={"Code-barres"}>
                    <span className={"info-value--mono"}>{productRcg.barCode ?? '—'}</span>
                </InfoRow>
                <InfoRow label={"Date d'analyse PCR"}>
                    <span className={"info-value--plain"}>
                        {productRcg.checkedAt
                            ? new Date(productRcg.checkedAt).toLocaleDateString('fr-FR')
                            : '—'
                        }
                    </span>
                </InfoRow>
                <InfoRow label={"N° de PCE associé"}>
                    <span className={"info-value--mono"}>{productRcg.pce ?? '—'}</span>
                </InfoRow>
            </div>
        </div>
    );
}

export { RcgInfoCard };
